import { webApiWithResponse } from "../../../../../core/http/httpThunks";
import { ClientContract } from "../../types";

export const createClientContractApi = (userId: string, contract: ClientContract) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/newclicontr",
		params: {
			userId
		},
		data: contract
	});

export default createClientContractApi;
